import { createFormHook } from "@tanstack/react-form";

import { AutocompleteField } from "src/components/Form/AutocompleteField";
import { CheckboxField } from "src/components/Form/CheckboxField";
import { DatePickerField } from "src/components/Form/DatePickerField";
import { FileUploadField } from "src/components/Form/FileUploadField";
import { PasswordField } from "src/components/Form/PasswordField";
import { PhoneField } from "src/components/Form/PhoneField";
import { SubmitButton } from "src/components/Form/SubmitButton";
import { TextField } from "src/components/Form/TextField";

// @note: https://github.com/TanStack/form/issues/1352
import { fieldContext, formContext } from "./form-context";

export { useFieldContext } from "./form-context";

export const { useAppForm } = createFormHook({
  fieldComponents: {
    TextField,
    PasswordField,
    DatePickerField,
    AutocompleteField,
    PhoneField,
    CheckboxField,
    FileUploadField,
  },
  formComponents: {
    SubmitButton,
  },
  fieldContext,
  formContext,
});
